import { mapActions } from 'vuex';

export default {
    methods: {
        ...mapActions('footer', ['setFooterMessage']),

        showFooterAppointmentsMessage() {
            this.setFooterMessage(`Can't find a suitable appointment? Call us on <a href="tel:+443306780850">0330 678 0850</a>`);
        },
    },
}
